import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {DownloadService} from "../../common/services/downloadService";
import {
    InvoiceAttachmentModel,
    InvoiceAttachmentSummaryModel,
    InvoiceAttachmentFilters
} from "../models/invoiceAttachment";

export class InvoiceAttachmentService {
    private static baseUrl = apiUrls.reports.invoiceAttachment;

    public static async generateReport(filters: InvoiceAttachmentFilters): Promise<AxiosResponse<PageableModel<InvoiceAttachmentModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<InvoiceAttachmentModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async generateSummaryReport(filters: InvoiceAttachmentFilters): Promise<AxiosResponse<InvoiceAttachmentSummaryModel>> {
        const url = `${Api.getUrl(this.baseUrl)}/summary`;

        return await http.get<InvoiceAttachmentSummaryModel>(`${Api.addParams(url, this.getParams(filters))}`);
    }

    public static async download(filters: InvoiceAttachmentFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    public static async downloadSummaryReport(filters: InvoiceAttachmentFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.downloadSummaryReport(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: InvoiceAttachmentFilters) {
        return `dateFrom=${filters.dateFrom}&dateTo=${filters.dateTo}&ferryEntityId=${filters.ferryEntityId}`;
    }
}
